import React, { useState } from "react";
import {
  Paper,
  Typography,
  Box,
  TextField,
  Button,
  Grid,
  Divider,
  ToggleButtonGroup,
  ToggleButton,
  Snackbar,
  Alert,
} from "@mui/material";
import {
  ArrowBack,
  CreditCard,
  AccountBalanceWallet,
} from "@mui/icons-material";
import { useNavigate } from "react-router-dom";

const PaymentPage = ({ formData, onBack }) => {
  const navigate = useNavigate();
  const [paymentMethod, setPaymentMethod] = useState("card");
  const [openSnackbar, setOpenSnackbar] = useState(false);

  const handlePaymentMethodChange = (_, newMethod) => {
    if (newMethod !== null) setPaymentMethod(newMethod);
  };

  const handlePaymentSubmit = () => {
    // setOpenSnackbar(true);
    navigate("/");
  };

  const handleCloseSnackbar = (_, reason) => {
    if (reason === "clickaway") return;
    setOpenSnackbar(false);
  };

  return (
    <Box
      sx={{
        minHeight: "100vh",
        backgroundColor: "#f0f2f5",
        py: 6,
        px: 2,
      }}
    >
      <Grid container justifyContent="center">
        <Grid item xs={12} sm={10} md={7} lg={6}>
          <Paper
            elevation={3}
            sx={{
              p: 5,
              borderRadius: 4,
              backgroundColor: "#ffffff",
            }}
          >
            {/* Header */}
            <Typography variant="h5" fontWeight={600} gutterBottom>
              Payment Details
            </Typography>
            <Typography variant="body2" color="text.secondary" mb={3}>
              Choose a payment method to complete your booking.
            </Typography>

            {/* Payment Type Toggle */}
            <ToggleButtonGroup
              value={paymentMethod}
              exclusive
              onChange={handlePaymentMethodChange}
              sx={{ mb: 3 }}
              fullWidth
            >
              <ToggleButton value="card" sx={{ flex: 1 }}>
                <CreditCard sx={{ mr: 1 }} />
                Card
              </ToggleButton>
              <ToggleButton value="upi" sx={{ flex: 1 }}>
                <AccountBalanceWallet sx={{ mr: 1 }} />
                UPI
              </ToggleButton>
            </ToggleButtonGroup>

            <Divider sx={{ mb: 3 }} />

            {/* Conditional Fields */}
            {paymentMethod === "card" ? (
              <Box component="form" noValidate autoComplete="off">
                <TextField
                  fullWidth
                  label="Cardholder Name"
                  size="small"
                  sx={{ mb: 2 }}
                />
                <TextField
                  fullWidth
                  label="Card Number"
                  size="small"
                  sx={{ mb: 2 }}
                />
                <Box display="flex" gap={2}>
                  <TextField label="Expiry MM/YY" size="small" fullWidth />
                  <TextField label="CVV" size="small" fullWidth />
                </Box>
              </Box>
            ) : (
              <TextField
                fullWidth
                label="Enter your UPI ID"
                size="small"
                placeholder="example@upi"
                sx={{ mb: 2 }}
              />
            )}

            {/* Payment Summary */}
            <Box
              mt={4}
              p={2}
              bgcolor="#f8f9fa"
              border="1px dashed #ccc"
              borderRadius={2}
              display="flex"
              justifyContent="space-between"
              alignItems="center"
            >
              <Typography fontWeight={500}>Total Amount</Typography>
              <Typography fontSize="1.2rem" fontWeight={700} color="green">
                ₹999
              </Typography>
            </Box>

            {/* Action Buttons */}
            <Box
              display="flex"
              justifyContent="space-between"
              mt={4}
              flexDirection={{ xs: "column", sm: "row" }}
              gap={2}
            >
              <Button
                variant="outlined"
                onClick={onBack}
                startIcon={<ArrowBack />}
                fullWidth
                sx={{ textTransform: "none" }}
              >
                Back
              </Button>
              <Button
                variant="contained"
                color="success"
                endIcon={
                  paymentMethod === "card" ? (
                    <CreditCard />
                  ) : (
                    <AccountBalanceWallet />
                  )
                }
                fullWidth
                onClick={handlePaymentSubmit}
                sx={{ textTransform: "none" }}
              >
                {paymentMethod === "card" ? "Pay with Card" : "Pay with UPI"}
              </Button>
            </Box>
          </Paper>
        </Grid>
      </Grid>

      {/* Success Snackbar */}
      <Snackbar
        open={openSnackbar}
        autoHideDuration={3000}
        onClose={handleCloseSnackbar}
        anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
      >
        <Alert
          onClose={handleCloseSnackbar}
          severity="success"
          variant="filled"
        >
          Payment successful!
        </Alert>
      </Snackbar>
    </Box>
  );
};

export default PaymentPage;
